import { extractData } from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  mapDtoToTrails as mapTrailsList,
  type TrailsListType,
} from "@/_pages/trails/model";

import {
  MapEcotrapsDtoSchema,
  MapPageInfoDtoSchema,
  PageDtoSchema,
  StationsDtoSchema,
} from "./schemas";
import type {
  MapEcotrapsDtoType,
  MapPageInfoType,
  StationsDtoType,
} from "./types";

export const mapDtoToTrails = (dto: unknown): TrailsListType =>
  mapTrailsList(dto);

export const mapDtoToStations = (dto: unknown): StationsDtoType => {
  const parsed = safeParseWithFallback(
    StationsDtoSchema,
    dto,
    "mapDtoToStations",
  );

  return extractData(parsed, dto, dto as StationsDtoType);
};

export const mapDtoToMapEcotraps = (dto: unknown): MapEcotrapsDtoType => {
  const parsed = safeParseWithFallback(
    MapEcotrapsDtoSchema,
    dto,
    "mapDtoToMapEcotraps",
  );

  const ecotraps = extractData(parsed, dto, dto as MapEcotrapsDtoType);

  if (!Array.isArray(ecotraps)) {
    return ecotraps;
  }

  // Пока поле переименовано не на всех стендах, подхватываем и старое status.
  // Итог обязательно приводим к null: если статуса нет ни там, ни там,
  // undefined не переживёт сериализацию пропсов из getServerSideProps
  return ecotraps.map(({ status, ...ecotrap }) => ({
    ...ecotrap,
    trailStatus:
      ecotrap.trailStatus ?? (status === "closed" ? "close" : status) ?? null,
  }));
};

export const mapDtoToMapPageInfo = (dto: unknown): MapPageInfoType => {
  const parsed = safeParseWithFallback(
    MapPageInfoDtoSchema,
    dto,
    "mapDtoToMapPageInfo",
  );

  return extractData(parsed, dto, dto as MapPageInfoType);
};

export const mapDtoToPage = (dto: unknown): any => {
  const parsed = safeParseWithFallback(PageDtoSchema, dto, "mapDtoToPage");

  return extractData(parsed, dto, dto as any);
};
